export default {
    skuId: '',
    activityId: '',
    skuNum: ''
}


// WEBPACK FOOTER //
// ./src/store/spell-buy/state.js